/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';
import appLoader from './task-message-loader.gif';

const loadingIndicatorWidth = 51;

const styles = StyleSheet.create({
  taskMessageLoadingIndicatorWrapper: {
    ...mixins.padding(12, 15),
    backgroundColor: 'grey',
    textAlign: 'left',
    borderRadius: 5,
    color: colors.generalGray,
    width: 'auto',
    maxWidth: '100%',
    display: 'inline-block',
    fontSize: 16,
    position: 'relative',
    wordWrap: 'break-word',
    marginBottom: 10,
  },
  messageLoadingIndicator: {
    // TODO Remove this - we don't support IE11!
    // Load in as background image instead img element in the template
    // because of IE bug that still exists in IE11 http://www.paulirish.com/2007/animated-gif-not-animating/
    background: `url(${appLoader}) no-repeat`,
    height: 12,
    width: loadingIndicatorWidth,
    backgroundSize: loadingIndicatorWidth,
    display: 'inline-block',
  },
});

export namespace TaskMessageLoadingIndicator {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const TaskMessageLoadingIndicator: React.FC = (...htmlProps) => {
  return (
    <div className={css(styles.taskMessageLoadingIndicatorWrapper)} {...htmlProps}>
      <span className={css(styles.messageLoadingIndicator)} />
    </div>
  );
};
